module.exports = function () {
  return new Promise(function (resolve) {
    require.ensure([], function (require) {
      resolve(require("!!/home/node/node_modules/babel-loader/lib/index.js??ruleSet[1].rules[0].use[0]!/home/node/frontend/src/metabase-lib/metadata/utils/ga-metadata.js"));
    });
  });
}